const OTP_EXPIRATION_MS = 60 * 1000;

const normalizeEmail = (email = "") => email.trim().toLowerCase();

const API_BASE = "https://us-central1-auravit-bb843.cloudfunctions.net";
const otpEndpoint = `${API_BASE}/sendOtpEmail`;
const smsOtpEndpoint = `${API_BASE}/sendOtpSms`;
const notificationEndpoint = `${API_BASE}/sendNotificationEmail`;

export const generateOtpCode = () =>
  Math.floor(100000 + Math.random() * 900000).toString();

export const createOtpRequestId = (prefix = "otp") =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const sendOtpEmail = async ({
  email,
  otp,
  purpose,
  requestId,
  expiresAt,
}) => {
  // Ensure OTP is properly formatted as 6-digit string
  const formattedOtp = String(otp).padStart(6, '0').slice(0, 6);

  // Log OTP for debugging
  console.log("📧 OTP Email Details:");
  console.log("   Email:", normalizeEmail(email));
  console.log("   OTP Code:", formattedOtp);
  console.log("   Purpose:", purpose);
  console.log("   Request ID:", requestId);
  console.log("   Expires At:", new Date(expiresAt).toISOString());

  const response = await fetch(otpEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: normalizeEmail(email),
      otp: formattedOtp,
      purpose,
      requestId,
      expiresAt,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    console.error("❌ OTP send failed:", data.error || `HTTP ${response.status}`);
    throw new Error(data.error || "Unable to send OTP email at the moment.");
  }

  return data;
};

export const sendOtpSms = async ({
  phone,
  otp,
  purpose,
  requestId,
  expiresAt,
}) => {
  // Ensure OTP is properly formatted as 6-digit string
  const formattedOtp = String(otp).padStart(6, '0').slice(0, 6);

  const response = await fetch(smsOtpEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      phone,
      otp: formattedOtp,
      purpose,
      requestId,
      expiresAt,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    console.error("❌ SMS OTP send failed:", data.error || `HTTP ${response.status}`);
    throw new Error(data.error || "Unable to send OTP SMS at the moment.");
  }

  return data;
};

export const sendPasswordChangeNotification = async ({ email }) => {
  const response = await fetch(notificationEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: normalizeEmail(email),
      subject: "Password Successfully Changed",
      message: "You have successfully changed your password.",
      type: "password-change-notification",
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    console.error("❌ Password change notification failed:", data.error || `HTTP ${response.status}`);
    // Don't throw error - password change should succeed even if notification fails
    console.warn("⚠️ Password change succeeded but notification email failed to send");
  }

  return data;
};

export const sendPasswordResetNotification = async ({ email }) => {
  const response = await fetch(notificationEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: normalizeEmail(email),
      subject: "Password Successfully Changed",
      message: "You have successfully changed your password.",
      type: "password-change-success-notification",
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    console.error("❌ Password reset notification failed:", data.error || `HTTP ${response.status}`);
    console.warn("⚠️ Password reset succeeded but notification email failed to send");
  }

  return data;
};

export { OTP_EXPIRATION_MS };
